var api = require("!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../node_modules/css-loader/dist/cjs.js??ref--3-1!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./organise-class-groups-modal.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



module.exports = content.locals || {};


//////////////////
// WEBPACK FOOTER
// ./components/one-roster-organise-class-groups/components/organise-class-groups-modal/organise-class-groups-modal.scss
// module id = Zo+M
// module chunks = 1